import { Widget } from '../../../widgets/shared/models/widget';
import { LoggregationParameterRequest } from './loggregation-parameter-request';
export class TemplateWidget extends Widget {
  public queryRequest: LoggregationParameterRequest;
}
